angular.module('unica_invitation_list.invitation_list_services')

.factory('InvitationListCreateService', function ($http, getBaseApiURL) {

	var invitationListCreateService = {};

	invitationListCreateService.create = function ( invitationListData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/create',
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListCreateService.clone = function ( invitationListId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/clone/' + invitationListId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	return invitationListCreateService;
});